module.exports = "./img/8b17bad40e9ae001260789c4e38a5bf2.png";